class DraggableScroll extends HTMLElement {
  constructor() {
    super();
    this.isDown = false;
    this.startX = 0;
    this.scrollLeft = 0;
    
    this.addEventListener('mousedown', this.onMouseDown.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    this.addEventListener('mouseup', this.onMouseUp.bind(this));
    this.addEventListener('mousemove', this.onMouseMove.bind(this));
  }

  onMouseDown(e) {
    this.isDown = true;
    this.classList.add('is-dragging');
    this.startX = e.pageX - this.offsetLeft;
    this.scrollLeft = this.scrollLeft; // Store current scroll position
  }

  onMouseLeave() {
    this.isDown = false;
    this.classList.remove('is-dragging');
  }

  onMouseUp() {
    this.isDown = false;
    this.classList.remove('is-dragging');
  }

  onMouseMove(e) {
    if (!this.isDown) return;
    e.preventDefault();
    const x = e.pageX - this.offsetLeft;
    const walk = (x - this.startX) * 2; // scroll-fast multiplier
    this.scrollLeft = this.scrollLeft - walk;
  }
}

if (!customElements.get('draggable-scroll')) {
  customElements.define('draggable-scroll', DraggableScroll);
}
